import { render } from "./StatusUpdate.vue?vue&type=template&id=59747ed4&scoped=true"
import script from "./StatusUpdate.vue?vue&type=script&lang=js"
export * from "./StatusUpdate.vue?vue&type=script&lang=js"

import "./StatusUpdate.vue?vue&type=style&index=0&id=59747ed4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59747ed4"]])

export default __exports__